export default __webpack_public_path__ + "static/media/image-3.009150c1.jpg";